import * as Yup from 'yup'

export const cdekValidation = {
  isPersonalDataAgreed: Yup.lazy(() => Yup.boolean().required().isTrue()),
  isMailingAgreed: Yup.lazy(() => Yup.boolean()),
}
